import { render, staticRenderFns } from "./SendSMSModal.vue?vue&type=template&id=23a235b2&scoped=true&"
import script from "./SendSMSModal.vue?vue&type=script&lang=js&"
export * from "./SendSMSModal.vue?vue&type=script&lang=js&"
import style0 from "./SendSMSModal.vue?vue&type=style&index=0&id=23a235b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a235b2",
  null
  
)

export default component.exports